// *** import of all used video.js basic files
let videojs:VideoJSStatic = require('expose-loader?videojs!videojs/es5/video.js'), // video.js (include compiled es5 files)
    objectAssign = require('object-assign');
    require('video.js/dist/video-js.css'); // default css of video.js

import hookManagerInstance from "../../communication/HookManager";
import {SkyClickPlayerHookType} from "../custom/SkyClickPlayer";


// export videojs object
export {videojs}; // make videojs public for everybody to import


// export hook types
export type PlayerComponentHookType =
    'BEFORE_SETUP' | // system hook to modify option object before player setup
    'SETUP'; // system hook, when videojs player setup is done


// register hook aliases for system hook types
hookManagerInstance.addOnce<SkyClickPlayerHookType>('STATIC_ONCE_INIT',function(){
    hookManagerInstance.registerAlias<PlayerComponentHookType>('beforesetup','BEFORE_SETUP');
    hookManagerInstance.registerAlias<PlayerComponentHookType>('setup','SETUP');
});


/**
 * WRAPPER CODE
 */
// Transform object to class - FIRST PART
interface IPlayerComponentWrapper extends VideoJSPlayer{
    // constructor signature the typescript way
    new():IPlayerComponentWrapper;
}

// define empty constructor function of the parent function
let IPlayerComponentWrapper = <IPlayerComponentWrapper><any>(function(){});
// change prototype empty parent class to prototype of 'Player' component
IPlayerComponentWrapper.prototype = (<any>videojs.getComponent('Player')).prototype;
// copy static function of 'Player' component to class object
objectAssign(IPlayerComponentWrapper, videojs.getComponent('Player'));

// Transform object to class - SECOND PART (extends wrapper class with object informations (interface) )
export default class PlayerComponentWrapper extends IPlayerComponentWrapper{

    /**
     * VideoJS reference for static methods
     * @type {VideoJSStatic}
     */
    static vjs:VideoJSStatic = videojs;

    /**
     * Reference to original static global video.js function
     * @type {VideoJSStatic}
     */
    public vjs:VideoJSStatic = null;

    protected selector:String = null;

    /**
     * Remember selector of video element
     * @param selector
     */
    constructor(selector:String){
        super(); // pseudo call (only for correct interface implementation)
        this.selector = selector;
        // save reference to static global videojs function
        this.vjs = videojs;
    }

    /**
     * Create a videojs instance
     * @param selector
     * @param options
     * @param ready
     * @returns {VideoJSPlayer}
     */
    static createInstance(selector:String|HTMLElement, options?: Object, ready?: () => void){
        return this.vjs(selector, options, ready);
    }

}


// WEBPACK FOOTER //
// ./src/app/components/wrappers/PlayerComponentWrapper.ts